module.exports = __webpack_public_path__ + "img/image13.645ee58b.png";